module.exports = __webpack_public_path__ + "img/01-Android.c506e737.png";